module.exports = __webpack_public_path__ + "front/img/kv03.545c71d6.png";